import { io } from 'socket.io-client';
import { config, getAuthToken } from './bridge.js';

let socket = null;
const listeners = {};
const lifecycleHandlers = { connect: [], disconnect: [], reconnect: [] };

export function onSocketLifecycle(kind, fn) {
  if (!lifecycleHandlers[kind]) return () => {};
  lifecycleHandlers[kind].push(fn);
  return () => {
    const arr = lifecycleHandlers[kind];
    const i = arr.indexOf(fn);
    if (i >= 0) arr.splice(i, 1);
  };
}

function fireLifecycle(kind, info) {
  for (const fn of lifecycleHandlers[kind]) {
    try { fn(info); } catch (e) { /* swallow */ }
  }
}

export async function connectSocket() {
  if (socket && socket.connected) return socket;
  const token = await getAuthToken();
  const url = (config.socketUrl || config.backendUrl).replace(/\/$/, '');
  socket = io(url, {
    transports: ['websocket'],
    auth: token ? { token } : {},
    reconnection: true,
    reconnectionDelay: 1000,
  });
  socket.on('connect', () => {
    socket.emit('ferris_lobby_subscribe');
    fireLifecycle('connect');
  });
  socket.on('reconnect', () => {
    try { socket.emit('ferris_lobby_subscribe'); } catch (_) {}
    fireLifecycle('reconnect');
  });
  socket.on('disconnect', (reason) => {
    fireLifecycle('disconnect', { reason });
  });
  for (const event of Object.keys(listeners)) {
    socket.on(event, (payload) => listeners[event].forEach((fn) => fn(payload)));
  }
  return socket;
}

export function on(event, handler) {
  listeners[event] = listeners[event] || [];
  listeners[event].push(handler);
  if (socket) socket.on(event, handler);
  return () => off(event, handler);
}

export function off(event, handler) {
  const arr = listeners[event];
  if (!arr) return;
  const i = arr.indexOf(handler);
  if (i >= 0) arr.splice(i, 1);
  if (socket) socket.off(event, handler);
}

export function disconnectSocket() {
  if (socket) {
    try { socket.emit('ferris_lobby_unsubscribe'); } catch (e) {}
    socket.disconnect();
    socket = null;
  }
}

/** Emit an event to the server. No-op if socket isn't connected. */
export function emit(event, payload) {
  if (!socket || !socket.connected) return false;
  try { socket.emit(event, payload); return true; } catch (_) { return false; }
}

/** Returns true if the socket is currently connected. */
export function isConnected() {
  return !!(socket && socket.connected);
}
